<div *ngIf="loading && showLoader">
    <p-progressSpinner [style]="{width: '30px', height: '30px'}" animationDuration=".5s"></p-progressSpinner>
</div>

<div class="row">
    <!--<div class="col-md-6">
      <div class="row margin-top-8">
        <div class="col-md-2 label">{{ 'bikeshop.modal.update_job_card.messaging.notification_header' | translate}}:</div>
        <div class="col-md-10 value">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon"><i class="fa fa-clipboard"></i></span>
            <input type="text" pInputText [(ngModel)]="header"
              placeholder="{{ 'bikeshop.modal.update_job_card.messaging.notification_header' | translate}}" />
          </div>
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-2 label">{{ 'bikeshop.modal.update_job_card.messaging.notification_text' | translate}}:</div>
        <div class="col-md-10 value">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon"><i class="fa fa-clipboard"></i></span>
            <input type="text" pInputText [(ngModel)]="text"
              placeholder="{{ 'bikeshop.modal.update_job_card.messaging.notification_text' | translate}}" />
          </div>
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-8"></div>
        <div class="col-md-4">
          <button pButton class="full-width" type="button"
            label="{{ 'bikeshop.modal.update_job_card.messaging.button.send_message' | translate}}"
            (click)="sendMessage()"></button>
          <p *ngIf="sendingState">
            {{ sendingState }}
          </p>
        </div>
      </div>
    </div>-->
    <div class="col-md-12">
        <div id="notification-container" class="notification-container">
            <div *ngIf="!loading && notifications.length===0">
                {{'bikeshop.modal.update_job_card.messaging.no-notifications' | translate}}
            </div>
            <div class="notification" *ngFor="let notification of notifications">
                <div [ngClass]="{'bike-shop': notification.Direction==='Outgoing', 'cyclist': notification.Direction==='Incoming'}">
                    <div class="cyclist-name"
                         *ngIf="notification.Direction==='Incoming'">{{jobcard.CyclistDescription}}</div>
                    <div class="cyclist-name" *ngIf="notification.Direction==='Outgoing'">{{notification.Type}}</div>
                    <div>{{notification.Message}}</div>
                    <div class="footer">
                      <div class="date">{{notification.CreatedDate | date : countryData.AngularDateFormat + " h:mm a"}}</div>
                      <div class="status">
                        <div *ngIf="notification.DeliveryStatus == 'accepted' || notification.DeliveryStatus == 'sent'"><span class="fa fa-check"></span></div>
                        <div *ngIf="notification.DeliveryStatus == 'delivered'" class="double-check"><span class="fa fa-check"></span><span class="fa fa-check"></span></div>
                        <div *ngIf="notification.DeliveryStatus == 'read'" class="double-check read"><span class="fa fa-check"></span><span class="fa fa-check"></span></div>
                        <div *ngIf="notification.DeliveryStatus == 'failed'" class="failed"><span class="fa fa-exclamation-triangle" pTooltip="{{ notification.FailureReason }}"></span></div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="whatsappFeatureEnabled" class="whatsapp-info-container">
  <!-- <div *ngIf="isWhatsappCustomMessageWindowOpen && defaultMessageType==='WHATSAPP'" class="whatsapp-title">{{ 'bikeshop.modal.update_job_card.messaging.messages_sent_will_use_whatsapp' | translate }}</div> -->
  <!-- <div *ngIf="hasInitiateChatTemplate && !isWhatsappCustomMessageWindowOpen">
    <div class="whatsapp-title red">{{ 'bikeshop.modal.update_job_card.messaging.messages_sent_will_not_use_whatsapp' | translate }}</div>
    <div class="whatsapp-info">{{ 'bikeshop.modal.update_job_card.messaging.messages_sent_will_not_use_whatsapp_info' | translate }}</div>
    <div class="initiate-chat" *ngIf="!busyInitiatingChat">
      <button pButton class="p-button-raised full-width p-mini" (click)="sendInitiateWhatsappChatTemplate()" label="{{'bikeshop.modal.update_job_card.messaging.initiate_whatsapp_conversation' | translate}}"></button>
    </div>
    <div class="initiate-chat" *ngIf="busyInitiatingChat">
      <p-progressSpinner [style]="{width: '30px', height: '30px'}" animationDuration=".5s"></p-progressSpinner>
    </div>
  </div> -->
  <div *ngIf="!hasInitiateChatTemplate && !isWhatsappCustomMessageWindowOpen">
    <div class="whatsapp-title red">{{ 'bikeshop.modal.update_job_card.messaging.no_whatsapp_initiate_chat_template' | translate }}</div>
  </div>

  <div class="message-type-container">
    <p-radioButton name="MessageType" value="WHATSAPP" label="Whatsapp" [(ngModel)]="defaultMessageType" [disabled]="!hasInitiateChatTemplate && !isWhatsappCustomMessageWindowOpen"></p-radioButton>
    <p-radioButton name="MessageType" value="SMS" label="SMS" [(ngModel)]="defaultMessageType" [disabled]="!hasInitiateChatTemplate && !isWhatsappCustomMessageWindowOpen"></p-radioButton>
  </div>

</div>


<div class="row margin-top-8">
    <div class="col-md-12">
        <div class="p-inputgroup">
          <textarea [rows]="5" type="text" pInputText [(ngModel)]="text" [maxlength]="defaultMessageType === 'SMS' ? 1500 : 1000"
                    placeholder="{{ 'bikeshop.modal.update_job_card.messaging.notification_text' | translate}}"
                    (keydown.control.enter)="sendMessage()"
                    [disabled]="sending"></textarea>
            <span class="send-icon" (click)="sendMessage()" [ngClass]="{'sending': sending}" pTooltip="CNTR + Enter"></span>
        </div>
    </div>
</div>
